import { ReactElement, useMemo } from 'react';
import { ChartContainer } from './chart-container';
import { UIText } from '@/ui';
import { useAnalyticsTranslation } from '../hooks';

type SingleValueChartProps = {
    title: string;
    description: string;
    value?: number | null;
    dateString?: string | null;
    loading?: boolean;
    error?: boolean;
};

export function SingleValueChart(props: SingleValueChartProps): ReactElement {
    const { title, description, value, dateString, loading, error } = props;
    const { t } = useAnalyticsTranslation();

    const valueString = useMemo<string>(() => {
        if (error) {
            return t('components.single_value_chart.error');
        } else if (loading) {
            return t('components.single_value_chart.loading');
        } else if (value || value === 0) {
            return value.toLocaleString();
        } else {
            return t('components.single_value_chart.no_data');
        }
    }, [value, loading, error, t]);

    return (
        <ChartContainer title={title} description={description}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16
                }}
            >
                <UIText medium variant="large">
                    {valueString}
                </UIText>
                <UIText variant="small" type="default2">
                    {dateString}
                </UIText>
            </div>
        </ChartContainer>
    );
}
